<template>
  <div class="c-led-pcb" v-visible="!loading">
    <img
      class="background"
      :src="noLED ? images.led_in_switch_80_no_led : images.led_in_switch_80"
      @load="onLoad"
    />
    <div class="leds">
      <div
        v-for="LED in finalLEDs"
        class="led"
        :class="{
          disabled: isPlaying,
        }"
        :key="LED.index"
        :style="LED.style"
        @mousedown.left="
          onMouseDownLeft({ color: frameRGB[LED.index], index: LED.index })
        "
        @mousedown.right="
          onMouseDownRight({ color: frameRGB[LED.index], index: LED.index })
        "
        @mouseenter="
          onMouseEnter({ color: frameRGB[LED.index], index: LED.index }, $event)
        "
        @contextmenu.prevent
      >
        <div class="content">
          <div
            class="background"
            :style="{ backgroundColor: frameRGB[LED.index] }"
          ></div>
          <div
            class="center"
            :style="{
              backgroundColor: frameRGB[LED.index],
              boxShadow:
                (LED.boxShadow || '0 0 0.45rem 0.2rem ') + frameRGB[LED.index],
              opacity: 1 || getLight(frameRGB[LED.index]),
            }"
          ></div>
        </div>
      </div>
    </div>
    <div class="spotlights">
      <div
        v-for="LED in spotlights"
        class="led"
        :class="{
          disabled: isPlaying,
        }"
        :key="LED.index"
        :style="LED.style"
        @mousedown.left="
          onMouseDownLeft(
            {
              color: spotlightFrameRGB[LED.index],
              index: LED.index,
            },
            true
          )
        "
        @mousedown.right="
          onMouseDownRight(
            {
              color: spotlightFrameRGB[LED.index],
              index: LED.index,
            },
            true
          )
        "
        @mouseenter="
          onMouseEnter(
            { color: spotlightFrameRGB[LED.index], index: LED.index },
            $event,
            true
          )
        "
        @contextmenu.prevent
      >
        <div class="content">
          <div
            class="background"
            :style="{ backgroundColor: spotlightFrameRGB[LED.index] }"
          ></div>
          <div
            class="center"
            :style="{
              backgroundColor: spotlightFrameRGB[LED.index],
              boxShadow:
                (LED.boxShadow || '0 0 0.45rem 0.2rem ') +
                spotlightFrameRGB[LED.index],
              opacity: 1 || getLight(spotlightFrameRGB[LED.index]),
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { speedList } from "@/utils";

export default {
  name: "CLedPcb80",
  props: {
    isPlaying: Boolean,
    speed: Number,
    frames: Array,
    spotlightFrames: Array,
    frameIndex: Number,
  },
  data() {
    return {
      loading: true,
      playingIndex: 0,
      noLEDs: [],
      LEDs: [
        { index: 0, style: { top: "0%", left: "0%" } },
        { index: 1, style: { top: "0%", left: "7.0%" } },
        { index: 2, style: { top: "0%", left: "12.5%" } },
        { index: 3, style: { top: "0%", left: "18.0%" } },
        { index: 4, style: { top: "0%", left: "23.6%" } },
        { index: 5, style: { top: "0%", left: "30.5%" } },
        { index: 6, style: { top: "0%", left: "36.1%" } },
        { index: 7, style: { top: "0%", left: "41.6%" } },
        { index: 8, style: { top: "0%", left: "47.2%" } },
        { index: 9, style: { top: "0%", left: "54.2%" } },
        { index: 10, style: { top: "0%", left: "59.7%" } },
        { index: 11, style: { top: "0%", left: "65.3%" } },
        { index: 12, style: { top: "0%", left: "70.8%" } },
        { index: 13, style: { top: "0%", left: "77.7%" } },
        { index: 14, style: { top: "0%", left: "84.7%" } },
        { index: 59, style: { top: "0%", left: "90.2%" } },
        { index: 58, style: { top: "0%", left: "95.8%" } },

        { index: 15, style: { top: "20.5%", left: "0%" } },
        { index: 16, style: { top: "20.5%", left: "5.6%" } },
        { index: 17, style: { top: "20.5%", left: "11.1%" } },
        { index: 18, style: { top: "20.5%", left: "16.7%" } },
        { index: 19, style: { top: "20.5%", left: "22.2%" } },
        { index: 20, style: { top: "20.5%", left: "27.7%" } },
        { index: 21, style: { top: "20.5%", left: "33.3%" } },
        { index: 22, style: { top: "20.5%", left: "38.8%" } },
        { index: 23, style: { top: "20.5%", left: "44.4%" } },
        { index: 24, style: { top: "20.5%", left: "50.0%" } },
        { index: 25, style: { top: "20.5%", left: "55.5%" } },
        { index: 26, style: { top: "20.5%", left: "61.0%" } },
        { index: 27, style: { top: "20.5%", left: "66.6%" } },
        { index: 28, style: { top: "20.5%", left: "72.5%", width: "9%" } },
        { index: 29, style: { top: "20.5%", left: "84.7%" } },
        { index: 74, style: { top: "20.5%", left: "90.2%" } },
        { index: 73, style: { top: "20.5%", left: "95.8%" } },

        { index: 30, style: { top: "36.3%", left: "0%", width: "7%" } },
        { index: 31, style: { top: "36.3%", left: "8.3%" } },
        { index: 32, style: { top: "36.3%", left: "14%" } },
        { index: 33, style: { top: "36.3%", left: "19.4%" } },
        { index: 34, style: { top: "36.3%", left: "24.9%" } },
        { index: 35, style: { top: "36.3%", left: "30.5%" } },
        { index: 36, style: { top: "36.3%", left: "36.0%" } },
        { index: 37, style: { top: "36.3%", left: "41.6%" } },
        { index: 38, style: { top: "36.3%", left: "47.2%" } },
        { index: 39, style: { top: "36.3%", left: "52.7%" } },
        { index: 40, style: { top: "36.3%", left: "58.2%" } },
        { index: 41, style: { top: "36.3%", left: "63.8%" } },
        { index: 42, style: { top: "36.3%", left: "69.4%" } },
        { index: 43, style: { top: "36.3%", left: "76.3%" } },
        { index: 44, style: { top: "36.3%", left: "84.7%" } },
        { index: 89, style: { top: "36.3%", left: "90.2%" } },
        { index: 72, style: { top: "36.3%", left: "95.8%" } },

        { index: 45, style: { top: "52.7%", left: "0%", width: "8%" } },
        { index: 46, style: { top: "52.7%", left: "9.8%" } },
        { index: 47, style: { top: "52.7%", left: "15.3%" } },
        { index: 48, style: { top: "52.7%", left: "20.9%" } },
        { index: 49, style: { top: "52.7%", left: "26.4%" } },
        { index: 50, style: { top: "52.7%", left: "31.9%" } },
        { index: 51, style: { top: "52.7%", left: "37.5%" } },
        { index: 52, style: { top: "52.7%", left: "43.0%" } },
        { index: 53, style: { top: "52.7%", left: "48.6%" } },
        { index: 54, style: { top: "52.7%", left: "54.1%" } },
        { index: 55, style: { top: "52.7%", left: "59.7%" } },
        { index: 56, style: { top: "52.7%", left: "65.3%" } },
        { index: 57, style: { top: "52.7%", left: "71.8%", width: "9.2%" } },

        { index: 60, style: { top: "69%", left: "0%", width: "11%" } },
        { index: 61, style: { top: "69%", left: "12.5%" } },
        { index: 62, style: { top: "69%", left: "18.1%" } },
        { index: 63, style: { top: "69%", left: "23.6%" } },
        { index: 64, style: { top: "69%", left: "29.2%" } },
        { index: 65, style: { top: "69%", left: "34.7%" } },
        { index: 66, style: { top: "69%", left: "40.2%" } },
        { index: 67, style: { top: "69%", left: "45.7%" } },
        { index: 68, style: { top: "69%", left: "51.3%" } },
        { index: 69, style: { top: "69%", left: "56.9%" } },
        { index: 70, style: { top: "69%", left: "62.5%" } },
        { index: 71, style: { top: "69%", left: "70.4%", width: "9.2%" } },
        { index: 87, style: { top: "69%", left: "90.2%" } },

        { index: 75, style: { top: "85%", left: "0%", width: "6.8%" } },
        { index: 76, style: { top: "85%", left: "8.3%" } },
        { index: 77, style: { top: "85%", left: "15.3%" } },
        { index: 78, style: { top: "85%", left: "22.2%" } },
        { index: 79, style: { top: "85%", left: "38.8%" } },
        { index: 80, style: { top: "85%", left: "55.5%" } },
        { index: 85, style: { top: "85%", left: "62.4%" } },
        { index: 86, style: { top: "85%", left: "69.4%" } },
        { index: 88, style: { top: "85%", left: "76.2%" } },
        { index: 83, style: { top: "85%", left: "84.7%" } },
        { index: 82, style: { top: "85%", left: "90.2%" } },
        { index: 81, style: { top: "85%", left: "95.8%" } },
      ],
      spotlights: [
        {
          index: 0,
          style: { top: "-40%", left: "-9%", width: "4%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
        {
          index: 1,
          style: { top: "-160%", left: "-9%", width: "4%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
        {
          index: 2,
          style: { top: "-1000%", left: "84%", width: "4%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
        {
          index: 3,
          style: { top: "-1000%", left: "88%", width: "4%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
        {
          index: 4,
          style: { top: "-1000%", left: "92%", width: "4%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
        {
          index: 5,
          style: { top: "-1000%", left: "96%", width: "4%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
        {
          index: 6,
          style: { top: "-1000%", left: "100%", width: "4%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
      ],
    };
  },
  computed: {
    ...mapState("profile80", {
      noLED: "noLED",
    }),
    ...mapState("assets", {
      images: "images",
    }),
    frameRGB() {
      if (this.frames) {
        const index = this.isPlaying ? this.playingIndex : this.frameIndex;
        return this.frames[index] ? this.frames[index].frame_RGB : [];
      }
      return [];
    },
    spotlightFrameRGB() {
      if (this.spotlightFrames) {
        const index = this.isPlaying ? this.playingIndex : this.frameIndex;
        return this.spotlightFrames[index]
          ? this.spotlightFrames[index].frame_RGB
          : [];
      }
      return [];
    },
    finalLEDs() {
      return this.noLED ? this.noLEDs : this.LEDs;
    },
  },
  watch: {
    isPlaying: function (isPlaying) {
      if (isPlaying) {
        this.play();
      }
    },
    speed() {
      this.play();
    },
  },
  methods: {
    getLight(hex) {
      const regs = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

      let r = parseInt(regs[1], 16);
      let g = parseInt(regs[2], 16);
      let b = parseInt(regs[3], 16);

      (r /= 255), (g /= 255), (b /= 255);

      const max = Math.max(r, g, b);
      const light = max * 2;
      return light.toFixed(3);
    },
    play() {
      console.log(this.spotlightFrames);
      this.playingIndex = 0;
      clearTimeout(this.timer);
      if (this.isPlaying) {
        const speed = speedList[this.speed - 1] - 2;
        this.timer = setInterval(() => {
          this.playingIndex = this.playingIndex + 1;
          if (this.playingIndex >= this.frames.length) this.playingIndex = 0;
        }, speed);
      }
    },
    onLoad() {
      this.loading = false;
    },
    onMouseDownLeft({ color, index }, isSpotlight) {
      this.$emit(isSpotlight ? "spotlight-click" : "led-click", {
        color,
        index,
      });
    },
    onMouseDownRight({ index }, isSpotlight) {
      this.$emit(isSpotlight ? "spotlight-click-right" : "led-click-right", {
        index,
      });
    },
    onMouseEnter({ color, index }, { which, buttons }, isSpotlight) {
      if (buttons === undefined ? which === 1 : buttons === 1) {
        this.$emit(isSpotlight ? "spotlight-click" : "led-click", {
          color,
          index,
        });
      } else if (buttons === undefined ? which === 3 : buttons === 2) {
        this.$emit(isSpotlight ? "spotlight-click-right" : "led-click-right", {
          index,
          solid: true,
        });
      }
    },
  },
  mounted() {
    // this.noLEDs = [...this.LEDs];
    // this.noLEDs.splice(0, 18);
    // this.noLEDs.splice(10);
    if (this.isPlaying) this.play();
  },
};
</script>

<style lang="scss" scoped>
.c-led-pcb {
  width: 100%;
  position: relative;

  .background {
    width: 100%;
    height: auto;
    position: relative;
    -webkit-user-drag: none;
  }

  .leds,
  .spotlights {
    width: 92.5%;
    height: 79.3%;
    position: absolute;
    left: 3.7%;
    top: 12.5%;

    .led {
      width: 4.2%;
      height: 12%;
      padding: 0 0.2%;
      position: absolute;
      cursor: pointer;

      &:hover .content .background {
        // display: block;
      }

      &.disabled {
        background: transparent;
        pointer-events: none;
        cursor: auto;
      }

      .content {
        width: 100%;
        height: 100%;
        position: relative;

        .background {
          width: 100%;
          height: 100%;
          position: absolute;
          display: none;
        }

        .center {
          width: 12px;
          height: 12px;
          left: 50%;
          top: 50%;
          margin-top: -6px;
          margin-left: -6px;
          border-radius: 12px;
          position: absolute;
          filter: brightness(120%);
        }
      }
    }
  }

  .spotlights {
    height: 10%;
    top: 90%;

    .led {
      height: 100%;
      width: 100%;

      .content {
        .center {
          width: 20px;
          height: 20px;
          margin-top: -10px;
          margin-left: -10px;
        }
      }
    }
  }
}
</style>
